import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el PROFEPACK después de comprar?',
    a: 'Inmediatamente después de confirmar el pago, recibís un email con el link de descarga. Acceso en menos de 5 minutos. Si no lo ves en inbox, revisá la carpeta de spam.'
  }, {
    q: '¿Sirve para mi provincia o solo para Buenos Aires?',
    a: 'Sirve para todo el país. Está alineado a los NAP (Núcleos de Aprendizaje Prioritarios) que son la base curricular nacional, y compatible con los Diseños Curriculares de todas las provincias: Buenos Aires, Córdoba, Santa Fe, Mendoza, Tucumán y el resto.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Es formato PDF listo para usar e imprimir. No es editable por diseño — así mantenemos la calidad visual y la coherencia pedagógica. Podés imprimirlo o usarlo desde la pantalla.'
  }, {
    q: '¿Los 6 bonos están incluidos en la oferta?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en tu compra sin costo extra. Los recibís junto con los 6 tomos en el mismo acceso.'
  }, {
    q: '¿Sirve si soy docente con poca experiencia?',
    a: 'Especialmente para vos. Todo está explicado paso a paso. No tenés que saber de antemano cómo armar una secuencia didáctica — el PROFEPACK ya la trae hecha. Solo seguís el orden y enseñás.'
  }, {
    q: '¿Sirve para cursos difíciles o con mucho desorden?',
    a: 'Sí. Las secuencias incluyen estrategias de gestión del aula y propuestas de trabajo colaborativo que ayudan a mantener la atención incluso en grupos complejos.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí. Todo el material está actualizado a los NAP vigentes y a los Diseños Curriculares provinciales actuales. Bibliografía oficial incluida al final de cada tomo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no quedás satisfecho por cualquier motivo, te devolvemos el 100% del dinero sin preguntas ni formularios. Simple.'
  }, {
    q: '¿Qué diferencia tiene PROFEPACK con otros packs que vi?',
    a: '3 diferencias clave: (1) Solucionario completo en cada tomo — la mayoría no lo incluye. (2) Organizado por grado con alineación curricular real, no genérica. (3) Los 6 bonos estratégicos pensados para el día a día del docente argentino, no relleno.'
  }, {
    q: '¿Incluye el Sistema de Gestión Docente?',
    a: 'Sí. El Sistema de Gestión Docente está incluido como uno de los 6 bonos estratégicos. Incluye registro de notas, seguimiento de asistencia, portfolio del alumno y herramientas de comunicación con familias.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-75">
          ❓ PREGUNTAS <span className="text-brand-accent" data-id="element-76">FRECUENTES</span>
        </h2>
        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-78">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-79">
                <span className="font-bold text-white text-lg pr-8" data-id="element-80">
                  <span className="text-brand-accent mr-2" data-id="element-81">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-82">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-83">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-84">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}